<template>
  <div class="stocks-card">
    <a :href="result.detailPage" class="stocks-card__header">
      <DefImg v-if="result.picture" :result="result.picture" />
    </a>

    <a :href="result.detailPage" class="stocks-card__footer">
      <span v-if="result.name" class="stocks-card__name">
        {{ result.name }}
      </span>
      <!--            <hr class="stocks-card__line">-->
      <span class="stocks-card__remains">
        <StocksLeft :result="result" :messages="messages" />
        <span v-if="!result.endTime && !result.isOver" class="stocks-card__day">
          {{ result.daysLeft }}
        </span>
        <DefTimer
          v-else-if="result.endTime && !result.isOver"
          :result="{ endTime: result.endTime }"
        />
      </span>
    </a>
  </div>
</template>

<script>
import DefImg from '@components/Def/DefImg/DefImg.vue';
import StocksLeft from '@components/Stocks/StocksLeft.vue';
import DefTimer from '@components/Def/DefTimer/DefTimer.vue';

export default {
  name: 'StocksCard',
  components: { DefTimer, StocksLeft, DefImg },
  props: ['result', 'messages'],
};
</script>

<style lang="scss" scoped>
.stocks-card {
  display: flex;
  flex-direction: column;
  &:hover {
    :deep(.def-img) {
      transform: scale(1.1);
    }
  }
  &__header {
    overflow: hidden;
  }
  &__footer {
    padding: 24px 16px;
    background-color: var(--background-light-pink);
    flex-grow: 1;
    @include point-md {
      padding: 32px 20px;
    }
    @include point-lg {
      padding: 40px 32px;
    }
  }

  &__name {
    display: block;
    font-weight: 600;
    font-size: rem(16);
    line-height: 125%;
    margin-bottom: 24px;
    transition: 0.2s linear color;
    @include point-md {
      font-weight: 600;
      font-size: rem(18);
      line-height: 135%;
    }
    &:hover {
      color: var(--color-link-hover-dark);
    }
    &:after {
      display: block;
      border: none;
      border-bottom: 1px dotted var(--background-grey);
      margin: 0 0 24px;
    }
  }

  &__line {
    //border: none;
    //border-bottom: 1px dotted var(--background-grey);
    //margin: 0 0 24px;
  }

  &__remains {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }

  &__day {
    font-weight: bold;
    font-size: rem(24);
    line-height: 100%;
    @include point-lg {
      font-size: rem(32);
    }
  }

  :deep(.def-img) {
    width: 100%;
    transform-origin: center;
    transition: 0.2s linear transform;
  }
}
</style>
